import { render, staticRenderFns } from "./ValuesModal.vue?vue&type=template&id=62f2f523&scoped=true&"
import script from "./ValuesModal.vue?vue&type=script&lang=js&"
export * from "./ValuesModal.vue?vue&type=script&lang=js&"
import style0 from "./ValuesModal.vue?vue&type=style&index=0&id=62f2f523&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f2f523",
  null
  
)

export default component.exports